"use client";

import Carousel from "@/components/common/Carousel";
import FlashSaleDealItem from "./FlashSaleDealItem";
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth";
import { Fragment, useEffect, useRef, useState } from "react";
import Flickity from "flickity";

type FlashSaleDealsDesktopProps = {
  type?: "sample" | "default";
  deals: any[]
  singleSlide?: boolean
  autoPlay?: number | false
  minWidth?: number
  maxWidth?: number
};

let initChange: any = {}

const FlashSaleDealsDesktop = ({
  type = "default",
  deals,
  singleSlide = false,
  autoPlay = false,
  minWidth,
  maxWidth,
}: FlashSaleDealsDesktopProps) => {
  const devicePassedWidth = useDevicePassedWidth(
    (screenWidth) => screenWidth
  );
  const refCarousal = useRef<Flickity>(null)

  const [shown, setShown] = useState<number>(-1)

  useEffect(() => {
    if (!devicePassedWidth) return;
    if (singleSlide) {
      setShown(devicePassedWidth <= (maxWidth ?? 991) ? 1 : 0)
      return
    }
    if (!!initChange[devicePassedWidth]) return;
    initChange = {
      [devicePassedWidth]: true
    }
    setShown(devicePassedWidth >= (minWidth ?? 577) ? 1 : 0)
  }, [devicePassedWidth, singleSlide, minWidth, maxWidth])

  useEffect(() => {
    if (singleSlide) return;
    return () => {
      initChange = {}
    }
  }, [singleSlide])

  // reloadCells() gọi ngay trong effect ở trên chạy trước khi React kịp commit style
  // hiện carousel ra DOM, nên Flickity đo cell lúc còn ẩn -> width/height = 0.
  // Đợi `shown` thực sự chuyển sang 1 (đã commit) rồi mới đo lại.
  useEffect(() => {
    if (shown === 1) {
      refCarousal.current?.reloadCells()
      refCarousal.current?.resize()
    }
  }, [shown])

  if (shown === 0) {
    return <Fragment />
  }

  const isMultiSlide = deals.length > 1

  return (
    <Carousel
      flickityRef={(ref) => { refCarousal.current = ref; }}
      className={`carousel-main home__deals-hotels--list${singleSlide ? " home__deals-hotels--list-single" : ""}${!singleSlide && minWidth === 992 ? " home__deals-hotels--list-wide" : ""}`}
      options={singleSlide ? {
        pageDots: false,
        cellAlign: "left",
        draggable: isMultiSlide,
        prevNextButtons: isMultiSlide,
        contain: true,
        wrapAround: isMultiSlide,
        autoPlay: isMultiSlide ? (autoPlay || 3000) : false,
        groupCells: 1,
        pauseAutoPlayOnHover: true,
      } : {
        pageDots: false,
        cellAlign: "left",
        draggable: true,
        prevNextButtons: true,
        contain: true,
        groupCells: true
      }}
      style={shown === -1 ? { opacity: 0 } : {}}
    >
      {deals.map((i: any) => {
        if (singleSlide) {
          return (
            <div
              key={i.id}
              className="flickity-container flickity-cell"
            >
              <FlashSaleDealItem
                item={i}
                itemType={type}
              />
            </div>
          );
        }
        return (
          <FlashSaleDealItem
            item={i}
            itemType={type}
            key={i.id}
            className="flickity-container flickity-cell"
          />
        );
      })}
    </Carousel>
  );
};

export default FlashSaleDealsDesktop;
